import React, { forwardRef, useEffect, useState, type JSX } from 'react';
import { InputFieldLabelText, InputFieldLabel, Input } from './styled';

interface InputFieldProps {
  name: string;
  value: string;
  label: string;
  className?: string;
  iconLeft?: JSX.Element;
  isValid?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (val: boolean) => void;
}

type Ref = HTMLInputElement;

const InputField = forwardRef<Ref, InputFieldProps>((props, ref): JSX.Element => {
  const { name, className, iconLeft, label, isValid = true, onChange, onKeyDown, onFocus } = props;
  const [value, setValue] = useState(props.value);
  const [focus, setFocus] = useState(false);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);

    if (onChange) {
      onChange(e);
    }
  };

  const handleFocus = (val: boolean) => {
    setFocus(val);
    if (onFocus) {
      onFocus(val);
    }
  };

  useEffect(() => {
    if (props.value !== value) {
      setValue('');
    }
  }, [props.value]);

  return (
    <InputFieldLabel htmlFor={name} focus={focus} className={className} hasIconLeft={!!iconLeft} isValid={isValid}>
      {iconLeft && iconLeft}
      <InputFieldLabelText hasValue={!!value} focus={focus} isValid={isValid}>
        {label}
      </InputFieldLabelText>
      <Input
        {...(ref ? { ref } : {})}
        type="text"
        name={name}
        id={name}
        value={value}
        onChange={(e) => handleOnChange(e)}
        onKeyDown={(e) => onKeyDown && onKeyDown(e)}
        onFocus={() => handleFocus(true)}
        onBlur={() => handleFocus(false)}
      />
    </InputFieldLabel>
  );
});

InputField.displayName = 'InputField';

export default InputField;
